import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as PortalAction from '../actions/portal';

/**
 * お知らせ画面のState型
 */
export interface IPortalState {
	readonly distanceLearning: PortalAction.IPortalDistanceLearning[];
	readonly eLearnings: PortalAction.IPortalELearning[];
	readonly groupTraining: PortalAction.IPortalGroupTraining[];
	readonly messages: PortalAction.IPortalMessage[];
	readonly whatsNews: PortalAction.IPortalWhatsNew[];
}

/**
 * お知らせ画面のState初期値
 */
const initialState: IPortalState = {
	distanceLearning: [],
	eLearnings: [],
	groupTraining: [],
	messages: [],
	whatsNews: [],
};

/**
 * お知らせ画面用reducer
 * @param state State
 * @param action アクション
 */
const portal = (state: IPortalState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	if (isType(action, PortalAction.setPortalMessages)) {
		return {
			...state,
			messages: action.payload.messages,
		};
	}

	if (isType(action, PortalAction.setPortalWhatsNews)) {
		return {
			...state,
			whatsNews: action.payload.whatsNews,
		};
	}

	if (isType(action, PortalAction.setPortalELearnings)) {
		return {
			...state,
			eLearnings: action.payload.eLearnings,
		};
	}

	if (isType(action, PortalAction.setPortalGroupTraining)) {
		return {
			...state,
			groupTraining: action.payload.groupTraining,
		};
	}

	return state;
};

export default portal;



// WEBPACK FOOTER //
// ./src/reducers/portal.ts